import {
  LexicalComposer,
} from "@lexical/react/LexicalComposer";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { $getRoot } from "lexical";

import { LinkNode } from "@lexical/link";
import { ListNode, ListItemNode } from "@lexical/list";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { CodeNode, CodeHighlightNode } from "@lexical/code";
import { AutoLinkNode } from "@lexical/link";
//import { HorizontalRuleExtension } from "@lexical/extension";
import { HorizontalRulePlugin } from "@lexical/react/LexicalHorizontalRulePlugin";
import { HorizontalRuleNode } from "@lexical/extension";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";

import ToolbarPlugin from "../components/ToolbarPlugin";
//import ImagesPlugin from "../components/ImagesPlugin";
import "../components/LexicalStyles.css";
import { ImageNode } from "../components/ImageNode";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { INSERT_IMAGE_COMMAND } from "../components/ImageNode";
import { $insertNodes } from "lexical";
import { $createImageNode } from "../components/ImageNode";
import React from "react";


export default function LexicalBlogEditor({ value, onChange }) {

  const initialConfig = {
    namespace: "BlogEditor",
    theme: {
      paragraph: "editor-paragraph",
      text: {
        bold: "editor-text-bold",
        italic: "editor-text-italic",
        underline: "editor-text-underline",
        fontFamily: {
            Arial: "font-arial",
            Georgia: "font-georgia",
            "Times New Roman": "font-times",
            Verdana: "font-verdana",
            "Courier New": "font-courier",
            "Trebuchet MS": "font-trebuchet",
        }
      }
    },
    onError(error) {
      console.error(error);
    },
    nodes: [
        HeadingNode,
        QuoteNode,

        ListNode,
        ListItemNode,

        CodeNode,
        CodeHighlightNode,

        LinkNode,
        AutoLinkNode,   // optional, detects links automatically

        //HorizontalRuleExtension,
        HorizontalRuleNode,

        // If you use ImagesPlugin:
        ImageNode,
    ],
    editorState: value ? JSON.stringify(value) : undefined
  };

  function ImageCommandPlugin() {
    const [editor] = useLexicalComposerContext();

    React.useEffect(() => {
        return editor.registerCommand(
        INSERT_IMAGE_COMMAND,
        ({ src }) => {
            editor.update(() => {
            const node = $createImageNode(src);
            $insertNodes([node]);
            });
            return true;
        },
        0
        );
    }, [editor]);

    return null;
    }

  return (
    <LexicalComposer initialConfig={initialConfig}>
      <ToolbarPlugin />
      <ImageCommandPlugin />

      <RichTextPlugin
        contentEditable={
          <ContentEditable
            className="blog-editor-content"
            style={{
              minHeight: "530px",
              background: "#FFFDF8",
              padding: "20px",
              borderRadius: "8px",
              border: "1px solid #ddd",
            }}
          />
        }
        //placeholder={<div style={{ padding: 20, opacity: 0.4 }}>Let yourself muse, and write with intellectual depth and clarity...</div>}
        ErrorBoundary={LexicalErrorBoundary}
      />

      <HistoryPlugin />
      <ListPlugin />
      <LinkPlugin />
      {/*<ImagesPlugin />*/}

      <HorizontalRulePlugin />

      <OnChangePlugin
        onChange={(editorState) => {
          const json = editorState.toJSON();
          onChange(json);
        }}
      />

      <MarkdownShortcutPlugin />
    </LexicalComposer>
  );
}
